//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignNavbar",
  data() {
    return {
      currentTab: "all"
    };
  },
  computed: {
    tabs() {
      return [{
        label: this.$tc("global.words.all", 1),
        value: "all"
      }, {
        label: this.$t("global.words.active"),
        value: "active"
      }, {
        label: this.$t("global.words.inactive"),
        value: "inactive"
      }];
    }
  },
  methods: {
    handleTabChange(val) {
      this.currentTab = val;
      this.$emit("tab-change", val);
    }
  }
});